import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'semantic-ui-react';
import { Button } from 'components';

import styles from './TagColor.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

const TagColor = ({ color, onCheckColor }) => {
  return (
    <div className={cx('tagColor-wrapper')}>
      <Button
        buttonType="material"
        fab
        onClick={() => {
          onCheckColor('red');
        }}
        className={cx('bt-tagColor', 'tag-red')}>
        {color === 'red' && <Icon name="checkmark" />}
      </Button>
      <Button
        buttonType="material"
        fab
        onClick={() => {
          onCheckColor('orange');
        }}
        className={cx('bt-tagColor', 'tag-orange')}>
        {color === 'orange' && <Icon name="checkmark" />}
      </Button>
      <Button
        buttonType="material"
        fab
        onClick={() => {
          onCheckColor('yellow');
        }}
        className={cx('bt-tagColor', 'tag-yellow')}>
        {color === 'yellow' && <Icon name="checkmark" />}
      </Button>
      <Button
        buttonType="material"
        fab
        onClick={() => {
          onCheckColor('olive');
        }}
        className={cx('bt-tagColor', 'tag-olive')}>
        {color === 'olive' && <Icon name="checkmark" />}
      </Button>
      <Button
        buttonType="material"
        fab
        onClick={() => {
          onCheckColor('lightgreen');
        }}
        className={cx('bt-tagColor', 'tag-lightgreen')}>
        {color === 'lightgreen' && <Icon name="checkmark" />}
      </Button>
      <Button
        buttonType="material"
        fab
        onClick={() => {
          onCheckColor('green');
        }}
        className={cx('bt-tagColor', 'tag-green')}>
        {color === 'green' && <Icon name="checkmark" />}
      </Button>
      <Button
        buttonType="material"
        fab
        onClick={() => {
          onCheckColor('pink');
        }}
        className={cx('bt-tagColor', 'tag-pink')}>
        {color === 'pink' && <Icon name="checkmark" />}
      </Button>
      <Button
        buttonType="material"
        fab
        onClick={() => {
          onCheckColor('purple');
        }}
        className={cx('bt-tagColor', 'tag-purple')}>
        {color === 'purple' && <Icon name="checkmark" />}
      </Button>
      <Button
        buttonType="material"
        fab
        onClick={() => {
          onCheckColor('violet');
        }}
        className={cx('bt-tagColor', 'tag-violet')}>
        {color === 'violet' && <Icon name="checkmark" />}
      </Button>
      <Button
        buttonType="material"
        fab
        onClick={() => {
          onCheckColor('blue');
        }}
        className={cx('bt-tagColor', 'tag-blue')}>
        {color === 'blue' && <Icon name="checkmark" />}
      </Button>
      <Button
        buttonType="material"
        fab
        onClick={() => {
          onCheckColor('lightblue');
        }}
        className={cx('bt-tagColor', 'tag-lightblue')}>
        {color === 'lightblue' && <Icon name="checkmark" />}
      </Button>
      <Button
        buttonType="material"
        fab
        onClick={() => {
          onCheckColor('emerald');
        }}
        className={cx('bt-tagColor', 'tag-emerald')}>
        {color === 'emerald' && <Icon name="checkmark" />}
      </Button>
      <Button
        buttonType="material"
        fab
        onClick={() => {
          onCheckColor('lightpink');
        }}
        className={cx('bt-tagColor', 'tag-lightpink')}>
        {color === 'lightpink' && <Icon name="checkmark" />}
      </Button>
      <Button
        buttonType="material"
        fab
        onClick={() => {
          onCheckColor('plum');
        }}
        className={cx('bt-tagColor', 'tag-plum')}>
        {color === 'plum' && <Icon name="checkmark" />}
      </Button>
      <Button
        buttonType="material"
        fab
        onClick={() => {
          onCheckColor('darkplum');
        }}
        className={cx('bt-tagColor', 'tag-darkplum')}>
        {color === 'darkplum' && <Icon name="checkmark" />}
      </Button>
      <Button
        buttonType="material"
        fab
        onClick={() => {
          onCheckColor('brown');
        }}
        className={cx('bt-tagColor', 'tag-brown')}>
        {color === 'brown' && <Icon name="checkmark" />}
      </Button>
      <Button
        buttonType="material"
        fab
        onClick={() => {
          onCheckColor('ash');
        }}
        className={cx('bt-tagColor', 'tag-ash')}>
        {color === 'ash' && <Icon name="checkmark" />}
      </Button>
      <Button
        buttonType="material"
        fab
        onClick={() => {
          onCheckColor('apricot');
        }}
        className={cx('bt-tagColor', 'tag-apricot')}>
        {color === 'apricot' && <Icon name="checkmark" />}
      </Button>
    </div>
  );
};

TagColor.propTypes = {};
TagColor.defaultProps = {};

export default TagColor;



// WEBPACK FOOTER //
// ./src/script/components/tag/TagColor.js